var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuburbs = function SvgSuburbs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#suburbs_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm1.452 22h-8.863a2.548 2.548 0 0 1-2.568-2.492 2.464 2.464 0 0 1 .318-1.239l4.436-7.959a2.6 2.6 0 0 1 4.5 0l4.425 7.953a2.467 2.467 0 0 1-.028 2.475A2.55 2.55 0 0 1 21.452 24Zm-4.43-11a.56.56 0 0 0-.5.283l-4.435 7.959a.474.474 0 0 0 .006.485.56.56 0 0 0 .5.273h8.863a.562.562 0 0 0 .5-.275.478.478 0 0 0 0-.489l-4.432-7.952a.557.557 0 0 0-.501-.284ZM8 23a1 1 0 0 0-1-1H3.35a1.35 1.35 0 0 1-1.184-1.994l6.652-12.3A1.329 1.329 0 0 1 10 7a1.326 1.326 0 0 1 1.183.706l1.227 2.267a1 1 0 0 0 1.76-.952l-1.226-2.266a3.343 3.343 0 0 0-5.885 0l-6.653 12.3A3.35 3.35 0 0 0 3.35 24H7a1 1 0 0 0 1-1Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "suburbs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSuburbs;